<button matRipple (click)="openDeleteDialog()" class="button" [title]="buttonTitle">
    {{ 'page.detail.buttons.delete_post' | translate }}
</button>
